import { CustomIcon } from '@tymbe/ui-icons';

const Chat = () => {
  const openChat = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.smartsupp?.('chat:open');
  };
  return (
    <div className="flex items-center gap-4 pl-10">
      <button
        className="size-10 p-2.5 bg-primary-300 rounded-full"
        onClick={openChat}
      >
        <CustomIcon name="Chat" className="text-secondary-600" />
      </button>
    </div>
  );
};

export default Chat;
